// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__T8xNS","head":"ProcedureTableInfo_head__30fd-"};